module.exports = __webpack_public_path__ + "img/zphd_zz_s1.d8f1231c.png";